import Headroom from "headroom.js";
import { showBackdrop, hideBackdrop } from "../components/backdrop";
import { throttle } from "../helpers";

(function ($) {
    const header = document.querySelector("header.site-header");
    const $mainHeader = $("#shopify-section-header");
    const $promoStrip = $("#section-announcement-wrapper");
    const $backdrop = $("#backdrop");
    const $promoStripContent = $(
        "#section-announcement-wrapper .strip-slideshow"
    );

    const getElementHeight = function ($element) {
        return $element.length ? $element.outerHeight(true) : 0;
    };

    const headroom = new Headroom(header, {
        tolerance: {
            up: 10,
            down: 0,
        },
        offset: header.clientHeight,
        onUnpin: function () {
            /* var filters = document.querySelector('.collection-filters-wrapper > .plp-control-toggles');
            filters.classList.add('scrolled');
            filters.classList.add('scrolled'); */
            makeSpaceForHeader();
        },
        onPin: function () {
            // var filters = document.querySelector('.collection-filters-wrapper > .plp-control-toggles');

            // window.addEventListener("scroll", function(){
            //     if(document.documentElement.scrollTop > 120){
            //         filters.classList.add('scrolled');
            //     } else {
            //         filters.classList.remove('scrolled');
            //     }
            // });
            $(window).trigger("resize");
        },
    });
    headroom.init();

    //////////// MAKING SPACE FOR NAV
    const $main = $("main.main-content");
    const makeSpaceForHeader = function () {
        const headerHeight = getElementHeight($mainHeader);
        const stripFullHeight = getElementHeight($promoStrip);
        const stripFullHeightContent = getElementHeight($promoStripContent);
        const headerFullHeight = headerHeight + stripFullHeight;
        const headerFullHeightForMain = headerHeight + stripFullHeightContent;

        document.body.style.setProperty(
            "--spacing-announcement",
            stripFullHeight + "px"
        );
        document.body.style.setProperty(
            "--spacing-header",
            headerFullHeight + "px"
        );

        $main.css({ paddingTop: headerFullHeightForMain + "px" });
    };

    $(window).on("resize", throttle(makeSpaceForHeader, 300));
    makeSpaceForHeader();

    $("#section-announcement-wrapper").on("init", function () {
        window.setTimeout(function () {
            makeSpaceForHeader();
        }, 100);
    });
    //////////// MAKING SPACE FOR NAV

    //////////// NAV HOVER AND CLICK
    const $desktopNav = $(".site-nav__main");
    if ($desktopNav.length) {
        if ($desktopNav.hasClass("site-nav__main--click")) {
            const $parents = $(".site-nav__main .site-nav__item--level-1 > a");

            $parents.on("click", function (evt) {
                var $el = $(this);
                evt.preventDefault();
                evt.stopImmediatePropagation();
                var isActive = $el.parent().hasClass("active");
                $el.parent().siblings().removeClass("active");

                if (isActive) {
                    $el.parent().removeClass("active");
                    document.body.classList.remove("nav-open");
                    $backdrop.css("pointer-events", "none");
                    hideBackdrop();
                } else {
                    $el.parent().addClass("active");
                    document.body.classList.add("nav-open");
                    $backdrop.css("pointer-events", "auto");
                    showBackdrop();
                }
            });
        } else if ($desktopNav.hasClass("site-nav__main--hover")) {
            $desktopNav.on(
                "mouseenter",
                '[data-meganav-level="1"]',
                showBackdrop
            );
            $desktopNav.on(
                "mouseleave",
                '[data-meganav-level="1"]',
                hideBackdrop
            );
        }
    }
    //////////// NAV HOVER

    $(".supports-touch .language-selector__wrapper__mobile").on(
        "click",
        function () {
            $(this).toggleClass("open");
        }
    );
})(jQuery);
